import React, { useState } from 'react';

import { useStyles } from './TerminationPreview.styles';
import { TerminationPreviewDocument } from 'app/components/TerminationPreviewDocument';
import { TerminationPreviewModal } from 'app/components/TerminationPreviewModal';

export default function TerminationPreview() {
  const classes = useStyles();

  const [isPreviewModalOpened, setIsPreviewModalOpened] = useState(false);

  const handleOpen = () => {
    setIsPreviewModalOpened(true);
  };

  const handleClose = () => {
    setIsPreviewModalOpened(false);
  };

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.thumbnail} onClick={handleOpen}>
          <TerminationPreviewDocument />
        </div>
      </div>
      {isPreviewModalOpened && (
        <TerminationPreviewModal onClose={handleClose} />
      )}
    </>
  );
}
